import '@bnnvara/typography';
import { breakpoints } from '@bnnvara/breakpoints';
import { css } from 'styled-components';
/* base button styling */

export const BaseButtonStyling = css`
  font-family: ${({
  theme
}) => theme.fonts.primary};
  box-sizing: border-box;
  cursor: pointer;
  border: none;
  appearance: none;
  outline: none;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
  width: ${({
  fullWidth
}) => fullWidth ? '100%' : 'auto'};
  padding: 6px 16px;

  ${breakpoints.md} {
    padding: 8px 24px;
  }

  ${breakpoints.lg} {
    padding: 8px 32px;
  }

  svg {
    width: 24px;
    height: 24px;
    margin: 0 8px;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }

  &:disabled,
  &[disabled] {
    color: ${({
  theme
}) => theme.base.white};
    background-color: ${({
  theme
}) => theme.primary.disabled};
    cursor: initial;

    &:hover,
    &:active,
    &:visited {
      color: ${({
  theme
}) => theme.base.white};
      background-color: ${({
  theme
}) => theme.primary.disabled};
    }
  }
`;
/* size variants */

export const small = css`
  font-size: 18px;
  line-height: 24px;
  background: transparent;
  font-weight: 700;
  padding: 6px 16px;

  ${breakpoints.md} {
    padding: 8px 24px;
  }

  ${breakpoints.lg} {
    padding: 8px 32px;
  }

  &:disabled,
  &[disabled] {
    color: ${({
  theme
}) => theme.base.white};
    background-color: ${({
  theme
}) => theme.primary.disabled};

    &:hover {
      color: ${({
  theme
}) => theme.base.white};
      background-color: ${({
  theme
}) => theme.primary.disabled};
    }
  }
`;
export const large = css`
  font-size: 18px;
  line-height: 24px;
  font-weight: 800;

  &:disabled,
  &[disabled] {
    color: ${({
  theme
}) => theme.base.white};
    background-color: ${({
  theme
}) => theme.primary.disabled};

    &:hover {
      color: ${({
  theme
}) => theme.base.white};
      background-color: ${({
  theme
}) => theme.primary.disabled};
    }
  }
`;
/* color variants */

export const red = css`
  background: ${({
  theme
}) => theme.primary.main};
  color: ${({
  theme
}) => theme.primary.contrastText};

  &:hover {
    background-color: ${({
  theme
}) => theme.primary.light};
  }

  &:active {
    background: ${({
  theme
}) => theme.primary.dark};
  }
`;
export const white = css`
  background-color: ${({
  theme
}) => theme.base.white};
  color: ${({
  theme
}) => theme.base.black};

  &:hover {
    background-color: ${({
  theme
}) => theme.tertiary.main};
  }

  &:active {
    background-color: ${({
  theme
}) => theme.tertiary.dark};
  }
`;
export const black = css`
  background: ${({
  theme
}) => theme.base.black};
  color: ${({
  theme
}) => theme.base.white};
`;
export const outline = css`
  background-color: transparent;
  color: ${({
  theme
}) => theme.secondary.dark};
  border-color: ${({
  theme
}) => theme.tertiary.dark};

  &:hover,
  &:focus {
    border-color: ${({
  theme
}) => theme.secondary.light};
  }
  &:active {
    border-color: ${({
  theme
}) => theme.secondary.main};
  }

  &:disabled,
  &[disabled] {
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }
  }
`;
export const underline = css`
  color: ${({
  theme
}) => theme.base.black};
  background: transparent;
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 18px;
  line-height: 24px;
  font-weight: 800;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  padding: 0;
  min-height: 32px;

  &:after {
    display: block;
    height: 3px;
    width: 100%;
    background: linear-gradient(
      to left,
      ${({
  theme
}) => theme.primary.main} 50%,
      ${({
  theme
}) => theme.base.black} 50%
    );
    background-size: 200% 100%;
    background-position: right bottom;
    transition: all ease 0.3s;
    position: absolute;
    bottom: 0;
    left: 0;
    content: '';
  }

  &:hover {
    &:after {
      background-position: left bottom;
    }
  }

  &:visited {
    color: ${({
  theme
}) => theme.base.black};
  }

  svg {
    margin: 0;
    height: 24px;
    width: 24px;
  }

  ${breakpoints.md} {
    font-size: 16px;
    padding: 0;
  }

  ${breakpoints.lg} {
    font-size: 18px;
    padding: 0;
  }
`;
export const text = css`
  color: ${({
  theme
}) => theme.base.black};
  text-transform: initial;
  text-decoration: none;
  background-color: transparent;
  position: relative;
  padding: 0;
  border: 0;

  &:visited {
    color: ${({
  theme
}) => theme.base.black};
  }

  &:after {
    display: block;
    height: 6px;
    width: ${({
  selected
}) => selected ? '100%' : 0};
    background-color: ${({
  selected,
  theme
}) => selected ? theme.primary.main : 'transparent'};
    position: absolute;
    bottom: -2px;
    left: 0;
    content: '';
    transition: width 0.2s ease-in-out;

    ${breakpoints.md} {
      height: 6px;
      bottom: -6px;
    }
  }

  @media (pointer: fine) {
    &:hover {
      &:after {
        background-color: ${({
  theme
}) => theme.primary.main};
        width: 100%;
      }
    }
  }
`;
export const ghost = css`
  background-color: transparent;
  color: ${({
  theme
}) => theme.base.white};
  border-color: ${({
  theme
}) => theme.base.white};

  &:hover,
  &:focus {
    color: ${({
  theme
}) => theme.base.black};
    background: ${({
  theme
}) => theme.base.white};
  }
  &:active {
    color: ${({
  theme
}) => theme.secondary.dark};
    border-color: ${({
  theme
}) => theme.secondary.dark};
  }

  &:disabled,
  &[disabled] {
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }
  }
`;
export const disabled = css`
  background-color: ${({
  theme
}) => theme.primary.disabled};
  color: ${({
  theme
}) => theme.base.white};

  &:hover,
  &:focus {
    color: ${({
  theme
}) => theme.base.black};
    background-color: ${({
  theme
}) => theme.primary.disabled};
  }
  &:active {
    color: ${({
  theme
}) => theme.secondary.dark};
    background-color: ${({
  theme
}) => theme.primary.disabled};
  }

  &:disabled,
  &[disabled] {
    color: ${({
  theme
}) => theme.base.white};
    background-color: ${({
  theme
}) => theme.primary.disabled};

    &:hover {
      color: ${({
  theme
}) => theme.base.white};
      background-color: ${({
  theme
}) => theme.primary.disabled};
    }
  }
`;
export const menu = css`
  color: ${({
  theme
}) => theme.base.black};
  text-transform: initial;
  text-decoration: none;
  background-color: #efeeef;
  position: relative;
  border: 0;
  background-color: ${({
  selected
}) => selected ? '#EEEEEE' : 'transparent'};
  width: 100%;
  padding-left: 16px;
  text-indent: 8px;

  &:visited {
    color: ${({
  theme
}) => theme.base.black};
  }

  ${breakpoints.md} {
    width: 100%;
    text-indent: 24px;
  }

  ${breakpoints.lg} {
    width: 100%;
    text-indent: 32px;
  }
`;